export default __webpack_public_path__ + "static/media/plurifonds_de.icon.f9d9f2ca.svg";